<syn-user-picker
    [value]="userId"
    [userType]="userType"
    [accountType]="accountType"
    [isBot]="isBot"
    [emitAndClear]="true"
    [placeholder]="placeholder"
    [required]="required"
    (userChange)="add($event)"></syn-user-picker>

<mat-chip-listbox>
    <mat-chip disableRipple *ngFor="let usr of users" matTooltip="{{usr.id}}" [removable]="removable" [disabled]="disabled" (removed)="remove(usr)" disabled>
        {{ displayFn(usr) }}
    <small class="email">{{usr.email}}</small>
        <mat-icon matChipRemove *ngIf="removable" svgIcon="close-circle"></mat-icon>
    </mat-chip>
</mat-chip-listbox>

